<template>
  <v-dialog v-model="showWindow" persistent max-width="500px">
    <v-card>
      <v-card-title primary-title class="justify-center">{{ locus }}</v-card-title>
      <v-card-text class="ma-0 py-0">
        <template v-for="a in annotations">
          <v-row v-for="(val, k) in a" :key="k" dense>
            <template v-if="val">
              <v-col cols="3" class="text-left">{{ k }}</v-col>
              <v-col cols="9" class="text-left">{{ val }}</v-col>
            </template>
          </v-row>
        </template>
        <v-divider class="my-1"></v-divider>
        <v-row dense
          ><v-col cols="3" class="text-left">DOWNLOAD</v-col>
          <v-col cols="9" class="text-left">
            <v-btn
              v-for="(l, i) in getLinks"
              :key="i"
              :href="l.link"
              target="_blank"
              class="mr-2"
              rounded
              color="primary"
              dark
              text
              small
            >
              {{ l.label }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="ma-0 py-0">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeHelpEvent()">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
export default {
  props: {
    locus: { type: String, default: '' },
    annotations: {
      type: Array,
      default: function() {
        return [];
      },
    },
  },
  data() {
    return {
      showWindow: true,
    };
  },
  computed: {
    ...mapGetters(['getReleaseUrl', 'getLocusURL']),
    getLocusVcfUrl() {
      let url = this.getLocusURL(this.locus) + '/vcf';
      return url;
      // if (this.testFileExists(url) == true) {
      //   return url;
      // } else {
      //   return '';
      // }
    },
    getLocusNwkUrl() {
      return this.getLocusURL(this.locus) + '/nwk';
    },
    getLocusMsaUrl() {
      return this.getLocusURL(this.locus) + '/msa';
    },
    getLinks() {
      // let links = [];
      // let vcfurl = this.getLocusVcfUrl;
      // console.log('vcfurl');
      // console.log(vcfurl);
      // let msaurl = this.getLocusMsaUrl;
      // let nwkurl = this.getLocusNwkUrl;
      // if (vcfurl != '') links.push({ label: 'vcf', link: vcfurl });
      // if (msaurl != '') links.push({ label: 'msa', link: msaurl });
      // if (nwkurl != '') links.push({ label: 'nwk', link: nwkurl });
      // return links;
      return [
        { label: 'vcf', link: this.getLocusVcfUrl },
        { label: 'msa', link: this.getLocusMsaUrl },
        { label: 'nwk', link: this.getLocusNwkUrl },
      ];
    },
  },
  methods: {
    closeHelpEvent() {
      this.showWindow = false;
      this.$emit('close');
    },
    testFileExists(f) {
      let fileAvailable = true;

      axios
        .get(f)
        .then(
          resp => {
            if (resp.data.hasOwnProperty('error') && resp.data.error == 'true') {
              console.log('dans le resp');
              fileAvailable = false;
            }
          },
          () => {
            console.log('dans le err');
            fileAvailable = false;
          }
        )
        .catch(() => {
          console.log('dans le catch');
          fileAvailable = false;
        })
        .finally(() => {
          console.log('dans le finally');
          console.log(fileAvailable);
          return fileAvailable;
        });

      //return fileAvailable;
    },
  },
};
</script>
<style scoped></style>
